import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InfoMessageModel } from 'src/models/info-message/infoMessage.model';
import { InfoMessageService } from 'src/services/info-messages/info-message.service';
import { ConfigService } from '@shared/services';
import { Config } from '@shared/models';

@Component({
    selector: 'pim-info-message',
    templateUrl: './info-message.component.html',
    styleUrls: ['./info-message.component.sass'],
    standalone: false
})
export class InfoMessageComponent implements OnInit, OnDestroy {
	private subscription: Subscription = new Subscription();
	allMessages: InfoMessageModel[] = [];
	displayQueue: InfoMessageModel[] = [];

	maxCount: number = 8;
	timeToLive: number = 3000;

	private currentTimeout!: number;

	private config: Config;

	constructor(private configService: ConfigService,
				private infomessageService: InfoMessageService) {
		this.config = this.configService.getConfig();
	}

	ngOnInit(): void {
		this.subscription = this.infomessageService.subject.subscribe(
			(msg: InfoMessageModel) => {
				this.addMessage(msg);
			}
		);
		this.maxCount = this.config.errorMessage.maxCount;
		this.timeToLive = this.config.errorMessage.timeToLive;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();

		clearTimeout(this.currentTimeout);
	}

	closeAll(): void {
		this.displayQueue = [];
		this.allMessages = [];
		clearTimeout(this.currentTimeout);
	}

	close(msg: InfoMessageModel): void {
		const index = this.displayQueue.indexOf(msg);
		if (index > -1) {
			this.displayQueue.splice(index, index + 1);
			// Nochmal die Q füllen
			this.showNextMessages();
		}
	}


	private addMessage(msg: InfoMessageModel): void {
		this.allMessages.push(msg);
		this.showNextMessages();
	}

	// Queue-Prinzip: Anzeige Queue auffüllen, bis kein Platz mehr ist
	// Wenn die Anzeige-Queue leer ist (wird nach der TTL geleert), schauen ob was neues reinkam
	private showNextMessages(): void {
		// Füll die AnzeigeQ auf, wenn nicht voll und daten da
		while (this.displayQueueHasSlot() && this.moreMessagesAvailable()) {
			this.addNextMessageToDisplayQueue();
			this.showDisplayQueueUntilTimeIsUp();
		}
	}

	private showDisplayQueueUntilTimeIsUp(): void {
		clearTimeout(this.currentTimeout);
		this.currentTimeout = window.setTimeout(() => {
			this.displayQueue = [];
			// Wenn fertig, schau rein, ob in der zwischenzeit was reinkam / noch etwas zu tun ist
			this.showNextMessages();
		}, this.timeToLive);
	}

	private addNextMessageToDisplayQueue(): void {
		const nextMessage = this.allMessages.splice(0, 1)[0];
		this.displayQueue.push(nextMessage);
	}

	private displayQueueHasSlot(): boolean {
		return this.displayQueue.length < this.maxCount;
	}

	private moreMessagesAvailable(): boolean {
		return this.allMessages.length > 0;
	}

}
